export default __webpack_public_path__ + "static/media/tau_thuy.60557cc4.png";